<template>
  <section
    v-if="visible"
    class="cookie-notice"
    aria-label="Cookie notice"
  >
    <div class="cookie-notice__content">
      <p class="mb-0">
        We use cookies on this site for personalised content and analytics.
        By using this site, you agree to the use of cookies.
        For more information, see our <router-link :to="{ name: 'terms-and-conditions' }">
          Terms and Conditions
        </router-link>
      </p>
      <b-button
        variant="primary"
        size="sm"
        class="cookie-notice__accept"
        @click="acceptCookies"
      >
        Accept cookies
      </b-button>
    </div>
  </section>
</template>

<script>
import { BButton } from 'bootstrap-vue'

const storageKey = 'structurededge-cookie-notice-accepted'

export default {
  components: { BButton },
  data() {
    return { visible: false }
  },
  mounted() {
    try {
      this.visible = localStorage.getItem(storageKey) !== 'true'
    } catch {
      this.visible = true
    }
  },
  methods: {
    acceptCookies() {
      try {
        localStorage.setItem(storageKey, 'true')
      } catch {
        // Still dismiss the notice if browser storage is unavailable.
      }
      this.visible = false
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/base/bootstrap-extended/include';
@import '@core/scss/base/components/include';

.cookie-notice {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: $zindex-fixed;
  padding: 0.75rem 1.5rem;
  padding-bottom: calc(0.75rem + env(safe-area-inset-bottom, 0px));
  color: $body-color;
  background: $white;
  border-top: 1px solid $border-color;
  box-shadow: 0 -2px 12px rgba($black, 0.08);

  &__content {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem 1.5rem;
    max-width: 1200px;
    margin: 0 auto;
  }

  &__accept {
    flex-shrink: 0;
  }

  a:focus-visible {
    outline: 2px solid currentColor;
    outline-offset: 2px;
  }
}

.dark-layout .cookie-notice {
  color: $theme-dark-body-color;
  background: $theme-dark-card-bg;
  border-color: $theme-dark-border-color;
}

@media print {
  .cookie-notice {
    display: none;
  }
}
</style>
